import { SchedulerTask, PipelineTaskParameters, AnyTaskParameters } from "../../../interfaces/scheduler";

export function createPipelineTask(innerTasks: AnyTaskParameters[], continueOnFail?: boolean): PipelineTaskParameters {
  return {
    type: SchedulerTask.Pipeline,
    innerTasks,
    continueOnFail,
  };
}
